import { Rows } from "Components/Layout/Table";

const AiAuditLogTable: Rows = {
    createdAt: {
        i18nLabel: 'Date',
        placeholders: [
            {
                element: 'p',
                size: 2
            }
        ]
    },
    provider: {
        i18nLabel: 'Provider & Model',
        placeholders: [
            {
                element: 'p',
                size: [2, 2],
            }
        ]
    },
    status: {
        i18nLabel: 'Status',
        placeholders: [
            {
                element: 'p',
                size: 1
            }
        ]
    },
    processingTimeMs: {
        i18nLabel: 'Duration',
        placeholders: [
            {
                element: 'p',
                size: 1
            }
        ]
    },
    totalTokens: {
        i18nLabel: 'Tokens',
        placeholders: [
            {
                element: 'p',
                size: 1
            }
        ]
    }
};

export default AiAuditLogTable;
